import moment from 'moment';
import { SERVER_FMT } from './clock';
import { ITEM_TYPES, itemType } from './items';

const TIME_FMT = 'hh:mm:ss A';

// Below this, a slot that has not started yet is treated as starting now (avoids a flash of idle).
export const START_TOLERANCE_MS = 3000;

// Map a bundle day to the flat slot shape the playback engine consumes.
export const mapDaySlots = (bundle, dayKey) => {
  const day = bundle?.days?.find((d) => d.date === dayKey);
  return (day?.slots || [])
    .map((s, i) => ({
      scheduleId: s.playlistId || i + 1,
      startAt: s.startAt,
      endAt: s.endAt,
      playlist: bundle.playlists?.[s.playlistId],
    }))
    .filter((slot) => slot.playlist);
};

/**
 * Picks the slot to play at local time `localStr` (SERVER_FMT) from a day's ordered slots: the
 * first slot that has not ended yet. Returns null when nothing is left today, otherwise the slot
 * plus how long until it starts (may be <= 0 when already running) and until it ends.
 */
export const planSlot = (slots, localStr) => {
  if (!slots?.length || !localStr) return null;

  const now = moment(localStr, SERVER_FMT);
  const date = now.format('DD-MM-YYYY');
  const time = moment(now.format(TIME_FMT), TIME_FMT);

  const slot = slots.find((s) => time.isBefore(moment(s.endAt, TIME_FMT)));
  if (!slot) return null;

  const at = (hhmmss) => moment(`${date} ${hhmmss}`, SERVER_FMT);
  return {
    slot,
    startInMs: at(slot.startAt).diff(now),
    endInMs: at(slot.endAt).diff(now),
  };
};

// Every media file referenced anywhere in the bundle's horizon (other item types have no file).
export const bundleFileNames = (bundle) => {
  const playlists = bundle?.playlists ? Object.values(bundle.playlists) : [];
  const names = playlists
    .flatMap((p) => p?.playlistContents || [])
    .filter((c) => itemType(c) === ITEM_TYPES.media)
    .map((c) => c?.file?.fileName)
    .filter(Boolean);
  return [...new Set(names)];
};
